let defaultColumns = {
  isLoading: false,
  isLoaded: false,
  data: null
};

export default function columnsReducer(state = defaultColumns, action) {
  let { type, data } = action;

  switch (type) {
    case 'LOAD_OFFER_COLUMNS':
      return Object.assign({}, state, {
        isLoading: true,
        isLoaded: false
      });

    case 'OFFER_COLUMNS_LOADED':
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        data: data
      });

    default:
      return state;
  }
}
